import { useBalance } from "@/shared/hooks/useBalance";
import { useSuppliersStore } from "@/shared/stores/suppliersStore";
import { useUiStore } from "@/shared/stores/uiStore";
import { formatCurrency } from "@/shared/lib/formatters";
import { BanknoteIcon } from "./assets/BanknoteIcon";
import styles from "./BalanceWidget.module.scss";
import { useToastStore } from "@/shared/stores/toastStore";
import { useEffect } from "react";

export function BalanceWidget() {
  const { selectedSupplierId } = useSuppliersStore();
  const { balance, isLoading, isError } = useBalance(selectedSupplierId);
  const { showToast } = useToastStore();
  const { openModal } = useUiStore();

  useEffect(() => {
    if (isError) {
      showToast("Ошибка загрузки баланса", "error");
    }
  }, [isError, showToast]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isLoading) return;
    openModal("TOP_UP_BALANCE", {});
  };

  const renderContent = () => {
    if (isError) {
      return (
        <>
          <BanknoteIcon className={styles.icon} />
          <span className={styles.amount}>— ₽</span>
        </>
      );
    }
    if (balance) {
      return (
        <>
          <BanknoteIcon className={styles.icon} />
          <span className={styles.amount}>
            {formatCurrency(balance.amount / 100)}
          </span>
        </>
      );
    }
    return null;
  };

  return (
    <>
      {!isLoading ? (
        <a href="#" className={styles.balanceWidget} onClick={handleClick}>
          {renderContent()}
        </a>
      ) : (
        <div className={styles.skeleton}></div>
      )}
    </>
  );
}
